'use client';
import React from 'react';
import { Anchor, AnchorProps } from '@repo/ui/src/components/Anchor';
import { classNames } from '@repo/ui/src/utils/classNames';
import { navigationClicked } from '@repo/ui/src/services/analytics';
import MobileAccordion from './_MobileAccordion';

export interface ColumnProps {
  links?: Array<AnchorProps>;
  title: string;
}

interface Props {
  columns: Array<ColumnProps>;
}

const FooterColumn = ({ columns }: Props) => {
  return (
    <div className="tw-grid tw-grid-cols-1 tw-w-full tw-mr-10 tw-mb-10 sm:tw-grid-cols-2 md:tw-gap-x-10 sm:tw-gap-y-4 md:tw-grid-cols-4">
      {columns?.map((col) => (
        <div className="tw-hidden sm:tw-block" key={col.title}>
          <h4 data-testid="mobile-nav-header" className="tra-text-web-sub-2 tw-text-white">
            {col.title}
          </h4>
          <ul
            className={classNames(
              'tw-list-none tw-pl-3 tw-mb-3 tw-w-full',
              'sm:tw-block sm:tw-pl-0',
            )}
          >
            {col.links?.map((link) => (
              <li
                key={link?.displayName}
                onClick={() =>
                  navigationClicked({
                    nav_type: 'Footer Navigation',
                    clicked_text: link?.displayName,
                    primary_header: col.title,
                  })
                }
              >
                <Anchor
                  className={classNames(
                    'tra-text-web-body-s tw-text-text-200 tw-block tw-py-2 tw-outline-offset-2',
                    'focus:tw-outline-action-300 focus:tw-outline-2 focus-visible:tw-outline',
                    'hover:tw-underline hover:tw-text-action-300',
                  )}
                  {...link}
                >
                  {link?.displayName}
                </Anchor>
              </li>
            ))}
          </ul>
        </div>
      ))}
      <MobileAccordion columns={columns} className="tw-list-none sm:tw-hidden" />
    </div>
  );
};

export default FooterColumn;
